import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function useCantinaHistorial() {
  const [ventas, setVentas] = useState([]);
  const [ventaDetalle, setVentaDetalle] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [error, setError] = useState('');

  const [filtros, setFiltros] = useState({
    desde: '',
    hasta: '',
  });

  const cargar = useCallback(async (filtrosActuales = {}) => {
    try {
      setCargando(true);
      setError('');

      const params = {};

      if (filtrosActuales.desde) {
        params.desde = filtrosActuales.desde;
      }

      if (filtrosActuales.hasta) {
        params.hasta = filtrosActuales.hasta;
      }

      const response = await api.get('/cantina/ventas', {
        params,
      });

      setVentas(
        Array.isArray(response.data) ? response.data : []
      );
    } catch (err) {
      console.error('Error cargando historial Cantina:', err);

      setVentas([]);
      setError(
        err?.response?.data?.error ||
          'No se pudo cargar el historial de ventas.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  const cargarDetalle = useCallback(async (id) => {
    try {
      setCargandoDetalle(true);
      setError('');

      const response = await api.get(`/cantina/ventas/${id}`);

      setVentaDetalle(response.data || null);

      return response.data;
    } catch (err) {
      console.error('Error cargando detalle Cantina:', err);

      setVentaDetalle(null);
      setError(
        err?.response?.data?.error ||
          'No se pudo cargar el detalle de la venta.'
      );

      return null;
    } finally {
      setCargandoDetalle(false);
    }
  }, []);

  const anularVenta = useCallback(async ({
    ventaId,
    autorizacionPin,
    motivo,
  }) => {
    try {
      setError('');

      await api.post(`/cantina/ventas/${ventaId}/anular`, {
        autorizacionPin,
        motivo,
      });

      await cargar(filtros);

      const response = await api.get(
        `/cantina/ventas/${ventaId}`
      );

      setVentaDetalle(response.data || null);

      return {
        ok: true,
        venta: response.data,
      };
    } catch (err) {
      console.error('Error anulando venta Cantina:', err);

      const mensaje =
        err?.response?.data?.error ||
        'No se pudo anular la venta.';

      setError(mensaje);

      return {
        ok: false,
        error: mensaje,
      };
    }
  }, [cargar, filtros]);

  const cerrarDetalle = () => {
    setVentaDetalle(null);
  };

  const aplicarFiltros = () => {
    cargar(filtros);
  };

  const limpiarFiltros = () => {
    const vacios = {
      desde: '',
      hasta: '',
    };

    setFiltros(vacios);
    cargar(vacios);
  };

  useEffect(() => {
    cargar({});
  }, [cargar]);

  return {
    ventas,
    ventaDetalle,
    cargando,
    cargandoDetalle,
    error,
    filtros,
    setFiltros,
    cargar,
    cargarDetalle,
    anularVenta,
    cerrarDetalle,
    aplicarFiltros,
    limpiarFiltros,
  };
}
